import { Link } from "react-router-dom";
import { categories } from "@/mocks/comics";

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
            漫画分类
          </h2>
          <p className="text-sm text-foreground-600 mt-2">探索不同类型的韩漫，找到你的最爱</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <div className="text-center">
                <h3 className="text-sm md:text-base font-medium text-foreground-900 whitespace-nowrap">{cat.name}</h3>
                <p className="text-xs text-foreground-500 mt-1">{cat.count}部作品</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}